
import SelectFileButton from "../parts/SelectFileButton.vue";
import SubmitButton from "../parts/SubmitButton.vue";
import Draggable from "vuedraggable";
import { defineComponent, reactive, ref, watch } from "vue";

interface GetImageData {
  id: number;
  name: string;
  url: string;
  date: string;
}

export default defineComponent({
  components: {
    SelectFileButton,
    SubmitButton,
    Draggable,
  },
  setup() {
    const dragging = ref<boolean>(false);
    const buttonDisable = ref<boolean>(true);
    const getReactiveImageData = reactive<GetImageData[]>([]);

    const getImageData = (imgData: GetImageData[]) => {
      imgData.forEach((element: any, index: number) => {
        const today = new Date();

        getReactiveImageData.push({
          id: index + 1,
          name: element.name,
          url: URL.createObjectURL(element),
          date: `${today.getFullYear()}${today.getMonth()}${today.getDate()}${today.getHours()}${today.getMinutes()}`,
        });
      });
    };

    const removeItem = (removeValue: GetImageData) => {
      if (confirm("削除してよろしいですか？")) {
        const getIndex = getReactiveImageData.findIndex(
          (data) => data.id === removeValue.id
        );

        getReactiveImageData.splice(getIndex, 1);
      }
    };

    watch(getReactiveImageData, (data) => {
      data.forEach((_, index) => {
        getReactiveImageData[index].id = index + 1;
      });

      if (getReactiveImageData.length > 0) {
        buttonDisable.value = false;
      } else {
        buttonDisable.value = true;
      }
    });

    return {
      getImageData,
      removeItem,
      getReactiveImageData,
      dragging,
      buttonDisable,
    };
  },
});
